<template>
  <div class="equity-dialog">
    <el-dialog
      :title=" type == 1?'汽车权益' : '商品权益'"
      :visible.sync="show"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
      >

        <el-form-item
          v-if="type==1"
          label="服务提供方"
          prop="supplier"
        >
          <el-select
            v-model="form.supplier"
            @change="changeSupplier"
          >
            <el-option
              v-for="item in supplierList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <template v-if="type==2">
          <el-form-item
            label="产品提供方"
            prop="supplier"
          >
            <el-select v-model="form.supplier">
              <el-option
                label="海威"
                value="HW"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="选择品牌"
            prop="brandName"
          >
            <el-select
              v-model="form.brandName"
              @change="changeBrandName"
              filterable
            >
              <el-option
                v-for="item in brandList"
                :key="item.brandName"
                :value="item.brandName"
                :label="item.brandName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="商品形态"
            prop="appearance"
            v-if="form.brandName"
          >
            <el-select
              v-model="form.appearance"
              @change="changeAppearance"
            >
              <el-option
                v-for="item in appearanceList"
                :key="item.appearance"
                :value="item.label"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <div class="flex">
          <el-form-item
            label="权益名称"
            prop="equityName"
          >
            <el-input
              v-model="form.equityName"
              :maxlength="type==1?8:6"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="描述"
            prop="equityDesc"
          >
            <el-input
              v-model="form.equityDesc"
              :maxlength="type==1?8:6"
            ></el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item
            label="图标"
            required
            prop="equityIcon"
          >
            <el-upload
              action="#"
              class="avatar-uploader"
              :show-file-list="false"
              :before-upload="upLoadImg"
            >
              <img
                v-if="form.equityIcon"
                :src="form.equityIcon"
                class="avatar"
              >
              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
              ></i>
            </el-upload>
          </el-form-item>
        </div>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="close">取 消</el-button>
        <el-button
          type="primary"
          @click="submit(type)"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { goodsEquityManageApi, carEquityManageApi, commonApi } from '@api/api'
const validatorgoodsImage = (rule, value, callback) => {
  if (!value) {
    callback('请上传图标')
  } else {
    callback()
  }
}
export default {
  name: 'equity-dialog',
  data () {
    return {
      form: {
        appearance: ''
      },
      brandList: [],
      appearanceList: [],
      supplierList: [
        {
          label: '广联-加油',
          value: 'GL_OIL'
        },
        {
          label: '广联-道路救援',
          value: 'GL_ROAD_RESCUE'
        },
        {
          label: '广联-轮胎保障',
          value: 'GL_TIRE_PROTECTION'
        },
        {
          label: '广联-盗抢无忧',
          value: 'GL_ROBBERY_PROTECTION'
        },
        {
          label: '广联-碰撞维修',
          value: 'GL_COLLISION_REPAIR'
        },
        {
          label: '广联-整车全损',
          value: 'GL_CAR_TOTAL_LOSS'
        },
        {
          label: 'e代驾',
          value: 'EDJ'
        }
      ],
      rules: {
        supplier: [
          { required: true, message: '请选择提供方', trigger: 'change' }
        ],
        brandName: [
          { required: true, message: '请选择品牌', trigger: 'change' }
        ],
        appearance: [
          { required: true, message: '请选择商品形态', trigger: 'change' }
        ],
        equityName: [
          { required: true, message: '请输入权益名称', trigger: 'blur' }
        ],
        equityDesc: [
          { required: true, message: '请输入描述', trigger: 'blur' }
        ],
        equityIcon: [
          { validator: validatorgoodsImage },
        ],
      }
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    type: Number,
    isEdit: Boolean,
    data: {
      type: Object,
      default: () => { }
    }
  },
  mounted () {
    goodsEquityManageApi.getGoodsBrandList().then(({ data }) => {
      this.brandList = data
    })
  },
  watch: {
    'isEdit' (n) {
      if (n) {
        this.form = JSON.parse(JSON.stringify(this.$parent.editData))
        if (this.type == 2) {
          this.form.appearance = { 1: '卡券', 2: '直充' }[this.$parent.editData.appearance]
        }
      }
    },
  },
  methods: {
    close () {
      this.form = {}
      this.$emit('update:show', false)
      this.$emit('update:isEdit', false)
      this.$refs.ruleForm.resetFields()
    },
    upLoadImg (file) {
      let fileName = file.name
      if (file.name.lastIndexOf('.') === -1) {
        this.$message.info('路径不正确')
        return false
      }
      let AllImgExt = '.jpg|.jpeg|.gif|.bmp|.png|.swf'
      let extName = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
      if (AllImgExt.indexOf(extName + '|') === -1) {
        this.$message.info('图片格式不正确')
        return false
      }
      // if (fileSize < 3145728) {
      if (window.FileReader) {
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (img) => {
          console.log(file)
          let type = fileName.split('.')[1]
          let imgUrl = img.target.result.split(',')[1]
          commonApi.upLoadImg({
            file: `${type}@${imgUrl}`
          }).then(({ code, message, data }) => {
            if (code == 0) {
              window.vm.$set(this.form, 'equityIcon', data)
            } else {
              this.$message.error(message)
            }
          })
        }
      }
    },
    changeSupplier (e) {
      console.log(e)
      this.supplierList.map(i => {
        if (i.value == e) {
          this.form.equityName = i.label
        }
      })
    },
    getAppearanceList (brandName) {
      goodsEquityManageApi.getAppearanceList({ brandName }).then(({ data }) => {
        console.log(data)
        data.map(i => i.label = { 1: '卡券', 2: '直充' }[i.appearance])
        this.appearanceList = data
        this.form.appearance = ''
      })
    },
    changeAppearance (e) {
      console.log(this.appearanceList)
      this.appearanceList.map(i => {
        if (i.label == e) this.form.brandId = i.brandId
      })
    },
    changeBrandName (e) {
      this.getAppearanceList(e)
    },
    submit (type) {
      console.log(this.form)
      let { form, isEdit } = this
      let target = type == 1 ? carEquityManageApi : goodsEquityManageApi
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (type == 2) {
            this.form.goodsCategoryId = this.$parent.goodsCategoryId
            this.form.appearance = form.appearance == '直充' ? 2 : 1
          }
          let apiName = 'createEquity'
          if (isEdit) apiName = 'updateEquity'

          target[apiName](this.form).then(({ code, data, message }) => {
            if (code == 0) {
              this.close()
              type == 1 ? this.$parent.getCarList() : this.$parent.getCategoryList()
            } else {
              this.$message.error(message)
            }
          })
        } else {
          return
        }
      })
    }
  }
}

</script>

<style scope>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.avatar-uploader {
  box-sizing: border-box;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  width: 80px;
  height: 80px;
  margin-left: 80px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
</style>